import type { ConfigProviderProps } from 'antd';

export const inlineNoticeConfig: ConfigProviderProps['alert'] = {
  className: 'app-inline-notice',
  styles: {
    root: {
      background: 'transparent',
      border: 0,
      borderRadius: 0,
      boxShadow: 'none',
      padding: '4px 0',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      columnGap: 8,
      rowGap: 8,
      minWidth: 0,
    },
    icon: {
      fontSize: 14,
      marginTop: 4,
      marginInlineEnd: 0,
    },
    section: { flex: '1 1 200px', minWidth: 0, overflowWrap: 'anywhere' },
    title: {
      color: 'var(--app-text)',
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '22px',
      marginBottom: 0,
    },
    description: {
      color: 'var(--app-muted)',
      fontSize: 13,
      lineHeight: '20px',
      marginTop: 4,
    },
    actions: { marginInlineStart: 0 },
  },
};
